import { FC, useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Link } from "react-router-dom";
import { Button } from "../../../../Components";
import pngBPM from "../../../../assets/bpm.svg";
import pngTech from "../../../../assets/tech.svg";
import pngDesign from "../../../../assets/design.svg";
import "./Card.css";

interface ICardProps {
  tribe: string ;
  index:number;
}

const Card: FC<ICardProps> = ({ tribe,index }) => {
  const [buttonHoverClass, setButtonHoverClass] = useState<string | null>(null);
  const [buttonHoverIndex, setButtonHoverIndex] = useState<number | null>(null);
  const [fade, setFade] = useState<boolean>(false);
  const image = [pngBPM, pngDesign, pngTech];
  
  const transition = useSpring({
    to: { opacity: 1, zIndex:10 },
    from: { opacity: 0, zIndex:10 },
    reverse: fade,
    delay: 1200,
    onRest: () => setFade(fade),
  });

  return (
        <animated.div style={transition} >
          <Link
            to={`tribu/${tribe[1]}`}
            className="card"
            onMouseEnter={() => {
              setButtonHoverClass("buttonHover");
              setButtonHoverIndex(index);
            }}
            onMouseLeave={() => {
              setButtonHoverIndex(null);
              setButtonHoverClass(null);
            }}
          >
            <li  className="linkToExpertise">
              <img src={image[index]} alt={`png${tribe[1]}`} />
              <div className="card-detail" key={index}>
                <h3>{`Tribu ${tribe[1]}`}</h3>
                <Button
                  hover={buttonHoverClass}
                  cardIndex={index}
                  buttonHoverIndex={buttonHoverIndex}
                  title="C'est parti !"
                  disabled="enable"
                />
              </div>
            </li>
          </Link>
        </animated.div>
  );
};

export default Card;
